import { DeltaServerWebSocketClient } from '@hds-products/delta-server-client';
import AdminItemBiddingPiniaVueAdapter from '../adapters/AdminItemBiddingPiniaVueAdapter';
import AdminEventActivityPiniaVueAdapter from '../adapters/AdminEventActivityPiniaVueAdapter';
import { adminEventRuntimeApiSdk } from './adminEventRuntimeApiSdk';
import EventEngineStatePiniaVueAdapter from '../adapters/EventEngineStatePiniaVueAdapter';
import ItemEngineStatePiniaVueAdapter from '../adapters/ItemEngineStatePiniaVueAdapter';
import EventRuntimeEngineServiceInfoPiniaVueAdapter from '../adapters/EventRuntimeEngineServiceInfoPiniaVueAdapter';

class AdminEventRuntimePiniaVueSdk {
    #_biddingBaseUrl;
    #_deltaServerClient;
    #_eventActivityPiniaVueAdapter;
    #_itemBiddingPiniaVueAdapter;
    #_eventEngineStatePiniaVueAdapter;
    #_itemEngineStatePiniaVueAdapter;
    #_ereServiceInfoPiniaVueAdapter;

    //`authenticate(wsUrl)` resolves what the delta socket's first frame carries: `{ accessToken, dpopProof }`
    constructor(biddingBaseUrl, deltaServiceUrl, customHeaderFn, authenticate) {
        this.#_biddingBaseUrl = biddingBaseUrl;
        this.#_deltaServerClient = new DeltaServerWebSocketClient(deltaServiceUrl, undefined, authenticate);
        this.#_eventActivityPiniaVueAdapter = new AdminEventActivityPiniaVueAdapter(this.#_deltaServerClient, this.#_biddingBaseUrl, customHeaderFn);
        this.#_itemBiddingPiniaVueAdapter = new AdminItemBiddingPiniaVueAdapter(this.#_deltaServerClient, this.#_biddingBaseUrl, customHeaderFn);
        this.#_eventEngineStatePiniaVueAdapter = new EventEngineStatePiniaVueAdapter(this.#_deltaServerClient, this.#_biddingBaseUrl, customHeaderFn);
        this.#_itemEngineStatePiniaVueAdapter = new ItemEngineStatePiniaVueAdapter(this.#_deltaServerClient, this.#_biddingBaseUrl, customHeaderFn);
        this.#_ereServiceInfoPiniaVueAdapter = new EventRuntimeEngineServiceInfoPiniaVueAdapter(this.#_deltaServerClient, this.#_biddingBaseUrl, customHeaderFn);
    }
    async initialize() {
        await this.#_deltaServerClient.connect()
        await this.#_eventActivityPiniaVueAdapter.initialize();
        await this.#_itemBiddingPiniaVueAdapter.initialize();
        await this.#_eventEngineStatePiniaVueAdapter.initialize();
        await this.#_itemEngineStatePiniaVueAdapter.initialize();
        await this.#_ereServiceInfoPiniaVueAdapter.initialize();
    }
    /*************************/
    /* EVENTS                */
    /*************************/
    async watchEvent(id) {
        await this.#_eventActivityPiniaVueAdapter.watchEventActivity(id)
        await this.#_eventEngineStatePiniaVueAdapter.watchEventEngineState(id)
    }
    async watchEvents(ids = []) {
        return Promise.all(ids.map(async (id) => { await this.watchEvent(id) }))
    }
    async unwatchEvent(id) {
        await this.#_eventActivityPiniaVueAdapter.unwatchEventActivity(id);
        await this.#_eventEngineStatePiniaVueAdapter.unwatchEventEngineState(id);
    }
    async unwatchEvents(ids = []) {
        return Promise.all(ids.map(async (id) => { await this.unwatchEvent(id) }));
    }
    /*************************/
    /* ITEMS                 */
    /*************************/
    async watchItemsByEventDetailId(eventId) {
        await this.#_itemBiddingPiniaVueAdapter.watchItemsByEventDetailId(eventId);
        await this.#_itemEngineStatePiniaVueAdapter.watchItemsByEventDetailId(eventId);
    }
    async unwatchItemsByEventDetailId(eventId) {
        await this.#_itemBiddingPiniaVueAdapter.unwatchItemsByEventDetailId(eventId);
        await this.#_itemEngineStatePiniaVueAdapter.unwatchItemsByEventDetailId(eventId);
    }
    /*************************/
    /* ERE Service Info      */
    /*************************/
    async watchEreServiceInfo() {
        await this.#_ereServiceInfoPiniaVueAdapter.watchAllEreServiceInfo();
    }
    async unwatchEreServiceInfo() {
        await this.#_ereServiceInfoPiniaVueAdapter.unwatchAllEreServiceInfo();
    }
}

export { AdminEventRuntimePiniaVueSdk }
export default AdminEventRuntimePiniaVueSdk;
